/**
 * Money, always to two decimals, so two amounts can be read against each other digit by digit.
 *
 * Shared because the overview and the detail view show the same figures and must agree on how
 * they look.
 */
export function formatAmount(value: number): string {
  return new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

/** Both totals a customer order document can state. */
export interface StatedTotals {
  total_order_price_excluding_taxes: number | null
  total_order_price_including_taxes: number | null
}

/**
 * The total to show for an order. Null where the document stated none.
 *
 * Without tax where the document stated it, otherwise with. The page does not say which: a price
 * on these documents almost never carries tax, and where one does it is usually a slip on the
 * customer's side. Naming the difference would put a caveat on most orders to explain the rare
 * one, and the check behind the figure holds regardless, because it is made against both.
 */
export function statedTotal(totals: StatedTotals): number | null {
  return totals.total_order_price_excluding_taxes ?? totals.total_order_price_including_taxes
}
